export default function Tiktok({ width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill-rule="evenodd"
      stroke-linejoin="round"
      stroke-miterlimit="2"
      clip-rule="evenodd"
      viewBox="0 0 64 64"
    >
      <path fill="none" d="M0 0h64v64H0z"></path>
      <path
        d="M33 6.001a1 1 0 0 0-1 1v36c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.24-5 5-5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1c-8.28 0-15 6.721-15 15 0 8.28 6.72 15 15 15 8.279 0 15-6.72 15-15V24.495a16.927 16.927 0 0 0 7 1.506h2a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-2c-3.863 0-7-3.137-7-7v-2a1 1 0 0 0-1-1h-8Z"
        fill="#5A6DA1"
        class="color000 svgShape"
      ></path>
    </svg>
  );
}
